<shared-modal
  [isOpen]="isOpen()"
  [config]="{
    title: 'Aviso',
    size: 'md',
    showCloseButton: true,
    closeOnBackdrop: false,
    closeOnEscape: false
  }"
  [customContent]="true"
  (modalClose)="closeModal()"
>
  <img
    src="assets/logo/logo_full.png"
    alt="Subito Logo"
    class="justify-self-center"
    width="150"
    height="150px"
  />
  <div *ngIf="loading(); else content">
    <ngx-skeleton-loader [theme]="{ 'border-radius': '4px', height: '20px', width: '80%' }"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{ 'border-radius': '4px', height: '16px', width: '60%', 'margin-top': '8px' }"></ngx-skeleton-loader>
  </div>
  <ng-template #content>
    <h3 class="text-lg font-bold text-gray-800" *ngIf="dateText(); else noDate">
      Actualizamos nuestros términos y condiciones el {{ dateText() }}
    </h3>
    <ng-template #noDate>
      <h3 class="text-lg font-bold text-gray-800">
        Actualizamos nuestros términos y condiciones
      </h3>
    </ng-template>
  </ng-template>

  <div class="flex items-center justify-center m-5">
    <button
      (click)="navigate('https://www.subito.com.mx/legal/', '_blank')"
      class="cursor-pointer bg-yellow-500 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out hover:bg-yellow-600"
    >
      Consultar aquí
    </button>
  </div>
  <div>
    <input
      #termsCb
      (change)="acceptTerms(termsCb.checked)"
      type="checkbox"
      id="acceptTerms"
      class="mr-2"
      required
    />
    <label for="acceptTerms" class="text-gray-800">
      Aceptar términos y condiciones
    </label>
  </div>
</shared-modal>
